const RATING_COMPUTATION_TYPE = {
  WEIGHTED_AVERAGE: 'WEIGHTED_AVERAGE',
  AVERAGE: 'AVERAGE',
};

export default RATING_COMPUTATION_TYPE;
